import { useHealthCheckLazyQuery } from "@common/utils/graphql";
import { useRecoilState } from "recoil";
import { NotificationKey, notificationState } from "./notificationState";

export const useAppNotification = () => {
  const [fetchNotifs, { loading: loadingNotifications }] =
    useHealthCheckLazyQuery();
  const [notifications, setNotifications] = useRecoilState(notificationState);

  const fetchNotifications = async () => {
    await fetchNotifs();
    const initialMap = new Map<NotificationKey, number>();

    // stubbed out
    Object.keys(NotificationKey).forEach((k) =>
      initialMap.set(
        k as unknown as NotificationKey,
        // data?.healthCheck.length || 0,
        20,
      ),
    );
    setNotifications(initialMap);
  };

  const decrementNotification = (k: NotificationKey) => {
    const oldMap = notifications;
    const oldValue = oldMap.get(k) || 1; // default to 1 so this does not go below 0
    oldMap.set(k, Math.max(0, oldValue - 1));
    setNotifications(oldMap);
  };

  const incrementNotification = (k: NotificationKey) => {
    const oldMap = notifications;
    const oldValue = oldMap.get(k) || 0; // default to 0
    oldMap.set(k, Math.max(0, oldValue + 1));
    setNotifications(oldMap);
  };

  return {
    fetchNotifications,
    loadingNotifications,
    decrementNotification,
    incrementNotification,
  };
};
